module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcontractors.net.au/images/splash-53beda6c7de818b0782b594ae211c2db.jpg";